import Slider from 'rc-slider';
import styled from 'styled-components';
import { rendererMaxWidth, rendererMinWidth } from '../../../../common/renderer/renderer-settings';
import { BouColor } from '../../../common/generic/global/bou-colors';
import { BouSpacingLevel, fluidSpacing } from '../../../common/generic/layout/bou-spacing';
import { fluidSpaceLg } from '../../../common/generic/utilities/fluid/fluid';
import { useRenderViewContext } from '../context';
import { ControlRoot, ControlRowContent, ControlRowLabel } from './shared';

export const Dimensions = () => {
  const { options, setOptions } = useRenderViewContext();
  return (
    <Root>
      <ControlRowLabel>Dimensions</ControlRowLabel>
      <ControlRowContent>
        <DimensionLabel>Width: {options.width}</DimensionLabel>
        <Slider
          handleStyle={{ borderColor: BouColor.TOOL_BORDER_BLACK }}
          trackStyle={{ backgroundColor: BouColor.TOOL_BORDER_DARK_GRAY }}
          max={rendererMaxWidth}
          min={rendererMinWidth}
          step={50}
          value={options.width}
          onChange={width => {
            setOptions({ ...options, width });
          }}
        />
      </ControlRowContent>
    </Root>
  );
};

const Root = styled(ControlRoot)`
  ${fluidSpaceLg('width', 200)}
`;

const DimensionLabel = styled.div`
  ${fluidSpacing('margin-bottom', BouSpacingLevel.MICRO)}
`;
